<div [hidden]="version !== KamonaOtpVersion.version_1">
<div class="w-full justify-between items-center flex box-border h-[80px] bg-white border-[1px] border-solid border-[#0357ee1a] rounded-[8px] px-[10px] gap-[16px]"
	id="otp-container-box">
	<div (click)="callFocus(index)" *ngFor="let pin of pinArray; let index = index">
		<input
			(keyup)="handleOnKeyupEvent($event, index)"
			id="{{ id }}-{{ index }}"
			inputmode="numeric"
			maxlength="1"
			nz-input
			pattern="[0 - 9]*"
			(paste)="onPaste($event)"
			(focus)="onPaste($event)"
			type="{{ type }}"
			class="max-h-[40px] max-w-[38px] p-0 font-normal text-[24px] border border-solid border-[#00000033] text-center rounded-[4px] focus:shadow-none hover:border-[#00000033] focus:border-primary"
		/>
	</div>
</div>
</div>
<div [hidden]="version !== KamonaOtpVersion.version_2" class="flex grow">
	<div
		class="full-width gap-[16px] kamona_otp_version_2 items-center flex"
		id="otp-container-box-v2">
		<div class="flex grow justify-center" (click)="callFocus(index)" *ngFor="let otp of pinArray; let index = index">
			<input
				(keyup)="handleOnKeyupEvent($event, index)"
				id="{{ idV2 }}-{{ index }}"
				inputmode="numeric"
				maxlength="1"
				nz-input
				[readOnly]="inputReadonly"
				pattern="[0 - 9]*"
				(paste)="onPaste($event)"
				(focus)="onPaste($event)"
				type="{{ type }}"
				class=" otp-box-size transition-opacity outline-0 border-0 leading-[24.8px] p-0 font-medium bg-[#F2F2F2] text-[20px] text-black text-center rounded-[4px] hover:border-transparent focus:border-solid focus:border-[1px] focus:bg-transparent focus:shadow-none focus:border-[#0361F0]"
			/>
		</div>
	</div>
</div>
